import { Radio as AntdRadio } from "antd";
import styled from "styled-components";
import { primitives } from "../../designsystem/primitives";

export const RadioGroup = styled(AntdRadio.Group)`
  .ant-radio .ant-radio-inner {
    border: 1.5px solid ${primitives.colors.blue[900]};
  }

  .ant-radio-checked .ant-radio-inner {
    border: 1.5px solid ${primitives.colors.blue[900]};

    &:after {
      background: ${primitives.colors.blue[900]};
    }
  }

  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none;
  }
`;
